import { Controller } from "@hotwired/stimulus"

// Modern toast: auto-dismiss after 5s, click X or anywhere on the
// element to dismiss early, slides out on dismiss.
export default class extends Controller {
  connect() {
    this.timeout = setTimeout(() => this.dismiss(), 5000)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  dismiss(event) {
    if (event) event.stopPropagation()
    clearTimeout(this.timeout)
    this.element.classList.add("ford-toast--dismissing")
    this.element.addEventListener("animationend", () => this.element.remove(), { once: true })
  }
}
